<template>
  <div id="nav" class="nav jp-column">
    <el-row type="flex" class="row-header">
      <el-col :span="3" class="header-logo">
        <img :src="logo" @click="setActiveNav(0, 'home')"/>
      </el-col>
      <el-col :span="14" class="hidden-xs-only">
        <nav class="Nav__global">
          <ul class="Nav__global__list" ref="MainHeader">
            <li class="Nav__global--company" @mouseenter="setCurrentNav(0)" @mouseleave="leave"  @click="setActiveNav(0, 'home')">
              {{$t('menu.home')}}
              <small v-if="$i18n.locale !== 'en'">Home</small>
            </li>
            <li class="Nav__global--company" @mouseenter="setCurrentNav(1)" @mouseleave="leave"  @click="setActiveNav(1, 'about', 'first')">
              {{$t('menu.about')}}
              <small v-if="$i18n.locale !== 'en'">About Us</small>
            </li>
            <li class="Nav__global--company" @mouseenter="setCurrentNav(2)" @mouseleave="leave"  @click="setActiveNav(2, 'technology')">
              {{$t('menu.technology')}}
              <small v-if="$i18n.locale !== 'en'">Technology</small>
            </li>
            <li class="Nav__global--research" @mouseenter="setCurrentNav(3)" @mouseleave="leave" @click="setActiveNav(3, 'acti')">
              {{$t('menu.acti')}}
              <small v-if="$i18n.locale !== 'en'">Our Business</small>
            </li>
            <li class="Nav__global--company" @mouseenter="setCurrentNav(4)" @mouseleave="leave"  @click="setActiveNav(4, 'recruit')">
              {{$t('menu.recruit')}}
              <small v-if="$i18n.locale !== 'en'">Opportunities</small>
            </li>
            <li class="Nav__global--business" @mouseenter="setCurrentNav(5)" @mouseleave="leave" @click="setActiveNav(5, 'newsList')">
              {{$t('menu.news')}}
              <small v-if="$i18n.locale !== 'en'">News</small>
            </li>
            <li class="Nav__global--business" @mouseenter="setCurrentNav(6)" @mouseleave="leave" @click="setActiveNav(6, 'contactUs')">
              {{$t('menu.contactUs')}}
              <small v-if="$i18n.locale !== 'en'">Contact Us</small>
            </li>
          </ul>
          <span class="Nav__global__slideLine" :style="navLineStyle || activeNavStyle"></span>
        </nav>
      </el-col>
      <el-col :span="7" class="jp-tab-lang hidden-xs-only">
        <el-row type="flex">
          <el-col :span="10">
            <div @click="goSearch" class="nav-search">
              <el-button>
                <i class="el-icon-search"></i>
                <span class="search-btn">{{ $t('search.btn') }}</span>
              </el-button>
            </div>
          </el-col>
          <el-col :span="6" class="jp-lang">
            <div @click="tabLang('cn')">
              <div>
                <img :src="cn" />
                <span :class="{ 'select-lang': $i18n.locale === 'cn' }">中文</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8" class="jp-lang">
            <div @click="tabLang('jp')">
              <img :src="jp" />
              <span :class="{ 'select-lang': $i18n.locale === 'jp' }">日本語</span>
            </div>
          </el-col>
          <!-- <el-col :span="3" class="pl-3">
            <div @click="contractUs">
              <i class="el-icon-message"></i>
            </div>
          </el-col> -->
        </el-row>
      </el-col>
      <!-- 进入手机版 -->
      <el-col :span="20" class="jp-mobile-menu-btn hidden-sm-and-up">
        <el-image v-show="!open" src="https://www.kaneka.co.jp/assets/img/common/menu_btn.png" @click="open = true"></el-image>
        <el-image v-show="open" src="https://www.kaneka.co.jp/assets/img/common/menu_btn_on.png" @click="open = false"></el-image>
      </el-col>
    </el-row>
    <div class="jp-mobile-menu" :class="{'open': open}">
      <div class="jp-mobile-menu-text">
        <div class="jp-mobile-line d-flex justify-between" @click="setActiveNav(0, 'home')">
          <span>{{$t('menu.home')}}</span>
          <span v-if="$i18n.locale !== 'en'">Home</span>
        </div>
        <div class="jp-mobile-line d-flex justify-between" @click="setActiveNav(1, 'about', 'first')">
          <span>{{$t('menu.about')}}</span>
          <span v-if="$i18n.locale !== 'en'">About Us</span>
        </div>
        <div class="jp-mobile-line d-flex justify-between" @click="setActiveNav(2, 'acti')">
          <span>{{$t('menu.acti')}}</span>
          <span v-if="$i18n.locale !== 'en'">Our Business</span>
        </div>
        <div class="jp-mobile-line d-flex justify-between" @click="setActiveNav(3, 'recruit')">
          <span>{{$t('menu.recruit')}}</span>
          <span v-if="$i18n.locale !== 'en'">Opportunities</span>
        </div>
        <div class="jp-mobile-line d-flex justify-between" @click="setActiveNav(4, 'newsList')">
          <span>{{$t('menu.news')}}</span>
          <span v-if="$i18n.locale !== 'en'">News</span>
        </div>
        <div class="jp-mobile-line d-flex justify-between" @click="setActiveNav(5, 'contactUs')">
          <span>{{$t('menu.contactUs')}}</span>
          <span v-if="$i18n.locale !== 'en'">Contact Us</span>
        </div>
      </div>
      <div class="p-3">
        <el-row align="middle" class="lang-text">
          <el-col :span="8" class="text-center">
            <div @click="tabLang('cn')">
              <img :src="cn" class="lang-icon"/>
              <span :class="{ 'select-lang': $i18n.locale === 'cn' }">中文</span>
            </div>
          </el-col>
          <el-col :span="8" class="text-center">
            <div @click="tabLang('jp')">
              <img :src="jp" class="lang-icon"/>
              <span :class="{ 'select-lang': $i18n.locale === 'jp' }">日本語</span>
            </div>
          </el-col>
          <el-col :span="8" class="text-center">
            <div @click="goSearch">
              <i class="el-icon-search"></i> {{ $t('search.btn')}}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="text-center" @click="open = false">
        <i class="el-icon-close jp-font-md"></i>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import logo from '@/assets/logo.png';
import cn from '@/assets/lang/cn.svg';
import jp from '@/assets/lang/jp.svg';
import en from '@/assets/lang/en.svg';
export default {
  name: 'navigation',
  data () {
    return {
      logo: logo,
      cn: cn,
      jp: jp,
      en: en,
      currentNav: null,
      activeNav: null,
      activeNavStyle: {},
      timer: null,
      open: false,
      currentNavStyle: {},
      screenWidth: document.body.clientWidth,
      selectLang: {
        key: 'jp',
        name: '中文'
      },
      langList: [
        {
          key: 'jp',
          name: '中文'
        },
        { 
          key: 'cn',
          name: '日本語'
        }
      ]
    }
  },
  
  mounted () {
    const that = this;
    this.activeNav = this.$route.query.route || 0;
    window.onresize = () => {
      return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
      })()
    }
    if (this.activeNav || this.activeNav===0) {
      this.setCurrentNav(this.activeNav);
      this.activeNavStyle = this.getNavStyle(this.activeNav)
    }
  },
  computed: {
    navLineStyle() {
      let style = this.currentNavStyle || this.activeNavStyle;
      let top = '';
      if (this.selectLang.key === 'en') {
        top = 55;
      } else {
        top = 64
      }

      return {
        top: top + 'px',
        width: `${style.width}` + 'px',
        left: `${style.left}` + 'px'
      }
    }
  },
  watch: {
    screenWidth(val){
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if(!this.timer){
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.setCurrentNav(this.activeNav)
        this.timer = true
        let that = this
        setTimeout(function() {
          that.timer = false
        },400)
      }
    },
    $route(route) {
      this.activeNav = parseInt(route.query.route);
      if (this.activeNav || this.activeNav === 0) {
        this.setCurrentNav(this.activeNav);
        this.activeNavStyle = this.getNavStyle(this.activeNav);
      }
    }
  },
  methods: {
    tabLang(lang) {
      let selectItem = _.remove(this.langList, function(n) {
        return n.key === lang;
      });
      this.langList.push(this.selectLang);
      this.selectLang = selectItem[0];
      this.$i18n.locale = lang;
      this.open = false;
      document.title = this.$t('main.title');
    },
    openMenu() {
      this.open = true;
    },
    leave() {
      if (this.activeNav == null && this.navLineStyle) {
        this.currentNavStyle.left = this.navLineStyle.left
        this.currentNavStyle.width = 0;
      } else {
        this.currentNavStyle.left = this.activeNavStyle.left
        this.currentNavStyle.width = this.activeNavStyle.width;
      }
    },
    setActiveNav(index, path, param) {
      // 点击导航时，设置激活样式
      this.open = false  //为了手机版关闭菜单
      this.activeNav = index
      this.activeNavStyle = this.getNavStyle(index)
      this.$router.push({ name: path, params: { type: param },query: { route: index } })
    },
    setCurrentNav (index) {
      // 鼠标移动到导航时，记录临时状态
      if (index || index === 0) {
        this.currentNav = index
        this.currentNavStyle = this.getNavStyle(index);
      }
    },
    getNavStyle (index) { // 根据导航的 index 移动下划线
      let childNodes = this.$refs.MainHeader.childNodes
      for(let i = 0; i < childNodes.length; i++) {
          if(childNodes[i].nodeName == "#text" && /\s/.test(childNodes[i].nodeValue)) {
              this.$refs.MainHeader.removeChild(childNodes[i]);
          }
      }
      // 根据当前导航的宽度，设置下划线的宽度
      let width = childNodes[index].clientWidth
      // 设置下划线的默认位置
      let left = width/2;
      if (index > 0) {
        // 计算左边导航的总宽度，设置为下划线的左移距离
        for (let i = 0; i < index; i++) {
          left += childNodes[i].clientWidth
        }
      }
      return {width, left}
    },
    // goHome() {
    //   this.activeNav = null;
    //   this.activeNavStyle = { width: 0 },
    //   this.currentNavStyle = this.activeNavStyle,
    //   this.$router.push({ name: 'home' })
    // },
    goSearch() {
      this.$router.push({ name: 'search' });
      this.open = false;
    },
    contractUs() {
      this.setActiveNav(1, 'about', 'fifth')
      this.open = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss">
@import '@/style/variables.scss';

.nav {
  height: 100%;
  background-color: $navBg;
  // line-height: 90px;
  cursor: pointer;
  ul {
    list-style: none;
  }
  .nav-search {
    i {
      color: $blue;
      font-size: 18px;
      font-weight: bold;
    }
    .search-btn {
      color: $textGrey;
      font-size: 12px;
      position: relative;
      bottom: 1px;
      margin-left: 0;
    }
    .el-button {
      padding: 5px 14px;
      border-radius: 50px;
      background-color: $grey;
      border: 1px solid transparent;
    }
  }
}

.Nav__global {
 position: relative;
  margin: 0 auto;
  text-align: center;
}
.Nav__global__list {
  padding: 0;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  transition: all .3s ease;
  small {
    display: block;
    color: #999;
    font-weight: 500;
  }
}
.Nav__global__item {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  text-decoration: none;
  color: #06173a;
  height: 90px;
  letter-spacing: .5pt;
}
.Nav__global__list li {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.Nav__global__slideLine {
  position: absolute;
  bottom: 0;
  height: 2.5px;
  background-color: #3b59a2;
  transition: all .3s ease;
  width: 0;
  transform: translateX(-50%);
}
.jp-mobile-menu {
  background-color: rgba(45, 77, 158, .95);
  position: absolute;
  z-index: 102;
  width: 100%;
  height: 0;
  left: 0;
  overflow: hidden;
  color: $white;
  font-size: 1.5rem;
  text-align: left;
  line-height: 42px;
  transition: height 0.5s;
  .jp-mobile-menu-text {
    padding: 1rem;

    .jp-mobile-line {
      border-bottom: 1px solid #9cabd1;
    }
  }
  .lang-icon {
    position: relative;
    top: 9px;
  }
  .lang-text {
    font-size: 14px;
    .select-lang {
      font-weight: bold;
      font-size: 15px;
      color: #03a9f4;
    }
  }
}
.open {
  height: 400px;
}
.jp-mobile-menu-btn {
  height: 50px;
  text-align: right;
  .el-image {
    height: 30px;
    width: 30px;
    cursor: pointer;
  }
}
.row-header {
  align-items: center;
  justify-content: space-between;
}

.jp-lang {
  position: relative;
  .jp-select-lang {
    line-height: 30px;
    display: none;
    position: absolute;
    top: 50px;
    left: -17px;
    width: 100px;
    background-color: rgba(251,251,251, 0.7);
    padding-top: 8px;
    padding-left: 18px;
    text-align: left;
    z-index: 100;
    font-size: 14px;
    border-radius: 5px;
  }
  .el-icon-caret-bottom {
    margin-left: 0;
    color: $textGrey;
    font-size: 12px;
    position: relative;
    bottom: 3px;
  }
  span {
    position: relative;
    bottom: 2px;
    font-size: 12px;
    color: #6c6969;
    &.select-lang {
      font-weight: bold;
      font-size: 15px;
      color: #0264B1;
    }
  }
  img {
    position: relative;
    top: 4px;
    width: 20px;
  }
}
.jp-lang:hover {
  .jp-select-lang {
    display: inline;
  }
}
@media (min-width: 768px) {
  .row-header {
    height: 90px;
  }
}
@media (max-width: 768px){
  .nav {
    line-height: 50px;
    cursor: unset;
  }
  .row-header {
    height: 60px;
  }
  .jp-mobile-menu-btn {
    height: 30px;
  }
  .jp-mobile-menu {
    .el-icon-message {
      border: 0;
    }
  }
}
@media (max-width: 320px) {
  
  .jp-mobile-menu {
    .lang-text {
      font-size: 12px;
    }
    .lang-icon {
      width: 26px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue